import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withKeys as _withKeys, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-316d8245"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-container" }
const _hoisted_2 = {
  class: "title ibf-h2",
  "data-testid": "agent-advanced-configuration-dialog--title"
}
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "component-desc",
  "data-testid": "agent-advanced-configuration-dialog--description"
}
const _hoisted_6 = {
  key: 0,
  class: "registry-type-desc beta_ii_dark_grey_ii ibf-h5"
}
const _hoisted_7 = {
  class: "component-container",
  "data-testid": "agent-advanced-configuration-dialog--component"
}
const _hoisted_8 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_incredi_select_menu = _resolveComponent("incredi-select-menu")!
  const _component_IncrediNote = _resolveComponent("IncrediNote")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return (_openBlock(), _createBlock(_component_q_form, {
    ref: "registryConfigurationForm",
    "data-testid": "agent-advanced-configuration-dialog",
    onSubmit: _ctx.handleSubmitConfiguration
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('agentsTable.setRegistryKey.title')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_incredi_select_menu, {
            class: "ibf-h6 menu-container",
            "data-testid": "agent-advanced-configuration-dialog--select-menu",
            disable: _ctx.requestCompleted,
            label: "Select Settings",
            options: _ctx.registryOptionsNames,
            value: _ctx.selectedRegistryName,
            onInput: _ctx.handleSelectMenuChange,
            "popup-content-class": "limited-height"
          }, null, 8, ["disable", "options", "value", "onInput"]),
          (_ctx.showRegistryComponent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.registryDescText.length > 0 && !_ctx.requestCompleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.registryDescText), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.registryComponent), _mergeProps(_ctx.registryComponentProps, {
                    ref: "myInput",
                    key: _ctx.selectedRegistryName,
                    "input-style": { color: _ctx.COLORS['Text/Dark'] },
                    "model-value": _ctx.selectedRegistryValue,
                    class: "tld-body",
                    onKeydown: _cache[0] || (_cache[0] = _withKeys((e) => { _ctx.getRegistryKeyByDisplayName() === 'BuildMonitorOutputFont' ? false : e.preventDefault()}, ["space"])),
                    "onUpdate:modelValue": _ctx.handleRegistryValueChange
                  }), null, 16, ["input-style", "model-value", "onUpdate:modelValue"]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.showMaxParallelLinkTargetsNote)
            ? (_openBlock(), _createBlock(_component_IncrediNote, {
                key: 0,
                class: "registry-note--container",
                type: "Information"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.setRegistryKey.registryNoteFor.MaxParallelLinkTargets')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_separator),
          _createVNode(_component_q_btn, {
            unelevated: "",
            class: _normalizeClass(`${_ctx.shouldEnableSubmitButton ? 'submit-button-enabled' : 'submit-button-disabled'} ibf-oneline1 submit-button`),
            "data-testid": "agent-advanced-configuration-dialog--submit-button",
            label: "Submit",
            type: "submit",
            "no-caps": "",
            disable: !_ctx.shouldEnableSubmitButton,
            onClick: _withModifiers(_ctx.handleSubmitConfiguration, ["prevent"])
          }, null, 8, ["class", "disable", "onClick"])
        ])
      ])), [
        [_directive_incredi_focus_trap, 'agent-registry-configuration']
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}